import { Box, CircularProgress, CircularProgressProps } from '@mui/material';
import styles from './Loading.styles';

interface LoadingComponentProps extends CircularProgressProps {
  fullPage?: boolean;
}

const LoadingComponent = function ({
  fullPage = false,
  color = 'primary',
  ...props
}: LoadingComponentProps): JSX.Element {
  return (
    <Box
      data-testid="page-loading"
      display="flex"
      flex={1}
      alignItems="center"
      justifyContent="center"
      sx={fullPage ? styles : {}}
    >
      <CircularProgress color={color} {...props} />
    </Box>
  );
};

export default LoadingComponent;
